import React from 'react';
import { Redirect, RouteProps } from 'react-router';

export const NotFoundRedirect = ({ location }: RouteProps) => (
  <Redirect to={{ ...location, ...{ state: { is404: true } } }} />
);
